import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-survey-hero',
  standalone: true,
  templateUrl: './survey-hero.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './survey-hero.component.scss',
})
export class SurveyHeroComponent {
  @Input() eyebrow = '';
  @Input() title = '';
  @Input() subtitle = '';
}
